var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg8 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 101",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "8")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.13,32.33A40.25,40.25,0,0,1,52.6,8.12a22.56,22.56,0,0,1,4.51,0A28.89,28.89,0,0,1,61,8.54a35.91,35.91,0,0,1,9.73,2.76,40,40,0,0,1,13.75,9.79,40.79,40.79,0,0,1,7.43,11.51,39.49,39.49,0,0,1,2.81,20.23c-.14,1.11-.86,3.06-.42,4.17s2.5,2.65,3.53,3.24c.7-.77.85-2.63,1.06-3.66q.39-1.86.61-3.74A45.53,45.53,0,0,0,88.73,17.74,44.87,44.87,0,0,0,67.16,4.43C50.65-.16,32.23,4.94,20.94,18c-5.33,6.15-9.27,13.72-10.22,21.87-.13,1.13.39,7.76-1.34,7.76-2.32,0-4.63,0-6.95,0a10.63,10.63,0,0,0-2.52.09c1.75,2.54,3.95,4.84,5.93,7.2L12,62.26c.26.32.41.41.73,0,4-4.79,8.18-9.45,12.18-14.25H15.82a1.14,1.14,0,0,1-.59-.11c-.36-.21-.37-.72-.34-1.14A44.67,44.67,0,0,1,18.13,32.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45,48a10,10,0,1,0,10.12-9.92A10.08,10.08,0,0,0,45,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M56.11,88.19a44.32,44.32,0,0,1-9.71-.89,38.29,38.29,0,0,1-12.16-4.91,2.56,2.56,0,1,0-2.69,4.34A46.68,46.68,0,0,0,55.3,93.2,12.66,12.66,0,0,0,60,92.65c-.85-1.27-1.72-2.49-2.51-3.76A1.36,1.36,0,0,0,56.11,88.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80,58.12a20.05,20.05,0,1,0,20.1,20A20.09,20.09,0,0,0,80,58.12Zm.63,35.08A14.83,14.83,0,0,1,65.08,79.59a13.84,13.84,0,0,1,2.54-9.41c.24-.35.41-.58.84-.14,6.85,6.85,13.71,13.68,20.66,20.61A21.65,21.65,0,0,1,80.62,93.2Zm11.5-6.61-21-21C79.37,60.13,86.74,63,91,67.76S96.14,82.44,92.12,86.6Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg8, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/8.12314f07.svg";
export { ForwardRef as ReactComponent };